import { wgs84togcj02 } from '@/utils/postion'
import { timetransition } from '@/utils/common'
import { massMarkers } from '@/pages/home/config/mapIcon'
import bus from '@/utils/bus'

// 全局label标签 用于显示时间
let labelMarker = null

/**
 * 将轨迹转换为高德可识别的数据
 * @param map
 * @param trace
 * @param carrierId
 * @returns {{mass, polyline: AMap.Polyline}|Error}
 */
export const renderTrace = function (map, trace = [], carrierId) {
  const mass = []
  const path = []
  if (labelMarker) {
    labelMarker.setMap(null)
  }
  if (!(trace instanceof Array)) {
    return new Error($t('integration.trace_is_not_an_array'))
  }
  if (!trace.length) {
    return {
      polyline: null,
      mass: null
    }
  }
  // 设置中心点
  const last = trace[trace.length - 1]
  // [AMap removed] map.setZoomAndCenter(18, wgs84togcj02(last.lng, last.lat))

  // 定义海量点的属性 与路径的属性
  trace.forEach((item, index) => {
    item.index = index
    const massItem = {
      lnglat: wgs84togcj02(item.lng, item.lat),
      name: timetransition(item.time),
      info: {
        ...item,
        id: carrierId
      }
    }
    // 已过滤的点
    if (item.filter) {
      // 附加一个id属性 获取详细轨迹信息时需要用到
      mass.push({
        ...massItem,
        style: 0
      })
    } else {
      // 原路径
      if (index === 0) {
        // 起点样式
        mass.push({
          ...massItem,
          style: 3
        })
      } else if (index === trace.length - 1) {
        // 终点样式
        mass.push({
          style: 4,
          ...massItem
        })
      } else {
        mass.push({
          style: item.reach ? 5 : 2,
          ...massItem
        })
      }
    }
    path.push(wgs84togcj02(item.lng, item.lat))
  })
  // [AMap removed] return buildPoint(map, mass, path)
  return { polyline: null, mass: null }
}

function buildPoint (map, massPoint, path) {
  // [AMap removed] Original implementation used AMap.Marker, AMap.Polyline and mass marker events:
  // [AMap removed]   const mass = massMarkers(massPoint)
  // [AMap removed]   labelMarker = new AMap.Marker({ content: ' ', map })
  // [AMap removed]   mass.on('mouseover', ...) - showed tooltip with time on hover
  // [AMap removed]   mass.on('mouseout', ...) - hid tooltip
  // [AMap removed]   const polyline = new AMap.Polyline({ path, showDir: true, strokeColor: '#28F', strokeWeight: 6, strokeStyle: 'solid' })
  // [AMap removed]   mass.on('click', ...) - emitted 'massClick' via bus
  // [AMap removed]   polyline.setMap(map); mass.setMap(map)
  return { polyline: null, mass: null }
}
